import Component from '../inherited/Component'
import Helpers from '../lib/Helpers'

export default class AnimationsTextAnimation extends Component {
  constructor (elem, theme, options, ctx) {
    super(elem, theme, options, ctx)
    this._rows = this._elem.querySelectorAll('[data-text-animation-row]')
  }

  mount () {
    // window.addEventListener('scroll', () => {
    //   if (this._reachedTop(this._elem)) {
    //     this._animate()
    //   }
    // })

    const observer = new window.IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        this._animate()
        return
      }
      for (let row of this._rows) {
        row.classList.remove('animated')
      }
    }, {
      root: null,
      threshold: 0
    })

    observer.observe(this._elem);

  }

  _reachedTop (element) {
    const rect = element.getBoundingClientRect()

    return (rect.top - this._options.distance_from_top <= 0)
  }

  _animate () {
    let index = 1
    for (let row of this._rows) {
      setTimeout(() => {
        row.classList.add('animated')
      }, index * this._options.animation_speed)
      index++
    }
  }
}